module.exports = __webpack_public_path__ + "static/media/1.68bf7517.jpg";